import React, { useState, useContext, useEffect } from "react";
import {
  Heading,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Button,
  Box,
  useToast,
} from "@chakra-ui/react";
import ProductItem from "./ProductItem";
import DeleteProduct from "./DeleteProduct";
import useFetch from "../../../hooks/useFetch";
import { ProductsContext } from "../../Context/ProductsContext";

const ProductList = ({
  purchase,
  setNewProductList = () => {},
  setIsEdited,
}) => {
  const [showNewProduct, setShowNewProduct] = useState(false);
  const [purchaseProducts, setPurchaseProducts] = useState(purchase.products);
  const [deletedProduct, setDeletedProduct] = useState(null);
  const [isDeleteProductOpen, setIsDeleteProductOpen] = useState(false);
  const { products, isLoadingProduct, getProducts } =
    useContext(ProductsContext);
  const { del, put, post } = useFetch();
  const toast = useToast();

  useEffect(() => {
    getProducts();
  }, []);

  const updateProduct = async (newProduct) => {
    if (purchase.id) {
      await put(
        `/suppliers/purchases/${purchase.id}/products/${newProduct.id}`,
        newProduct
      ).then((res) => {
        setPurchaseProducts(res.products);
      });
    } else {
      let newProducts = [...purchaseProducts];
      let index = newProducts.findIndex((p) => p.id == newProduct.id);
      newProducts[index] = newProduct;
      setPurchaseProducts(newProducts);
      setNewProductList(newProducts);
    }
  };

  const addProduct = async (newProduct) => {
    if (purchase.id) {
      await post(
        `/suppliers/purchases/${purchase.id}/products`,
        newProduct
      ).then((res) => {
        setPurchaseProducts(res.products);
      });
    } else {
      let newProducts = [...purchaseProducts];
      newProducts = [newProduct, ...newProducts];
      setPurchaseProducts(newProducts);
      setNewProductList(newProducts);
    }
  };

  const removeProduct = async (product) => {
    try {
      if (purchase.id) {
        await del(
          `/suppliers/purchases/${purchase.id}/products/${product.productId}`
        );
      }
      toast({
        title: "Artículo borrado con éxito.",
        status: "success",
        duration: 4000,
        isClosable: true,
      });
      let newProducts = [...purchaseProducts];
      newProducts = newProducts.filter((prod) => prod.id !== product.id);
      setPurchaseProducts(newProducts);
      setNewProductList(newProducts);
    } catch (e) {
      toast({
        title: "Se ha producido un error.",
        description: e,
        status: "error",
        duration: 4000,
        isClosable: true,
      });
    }
  };

  const deleteProductHandler = (product) => {
    setDeletedProduct(product);
    setIsDeleteProductOpen(true);
  };

  return (
    <>
      <Heading variant="h2">Artículos</Heading>

      {(purchase.statusId == 1 || !purchase.id) && (
        <Button
          my="2"
          colorScheme="blue"
          onClick={() => setShowNewProduct(true)}
          isDisabled={showNewProduct}
        >
          + Artículo
        </Button>
      )}

      <Box overflowX={"scroll"} pb={"0.5rem"}>
        <Table variant="striped" colorScheme="gray" fontSize="0.8em" w="100%">
          <Thead>
            <Tr>
              <Th fontSize="0.8em">Artículo</Th>
              <Th fontSize="0.8em">Cantidad</Th>
              <Th fontSize="0.8em">Precio ($)</Th>
              <Th fontSize="0.8em" textAlign="center">
                Actualizar Stock
              </Th>
              <Th fontSize="0.8em" textAlign="center">
                Actualizar Precio
              </Th>
              <Th fontSize="0.8em" textAlign="center">
                Acciones
              </Th>
            </Tr>
          </Thead>
          {!isLoadingProduct && (
            <Tbody>
              {showNewProduct && (
                <ProductItem
                  key={Math.random().toString(36).substring(2, 8)}
                  product={{}}
                  setShowNewProduct={setShowNewProduct}
                  addProduct={addProduct}
                  initialAction={"new"}
                  products={products}
                  setIsEdited={purchase.id ? () => {} : setIsEdited}
                />
              )}
              {purchaseProducts.map((product) => (
                <ProductItem
                  key={product.id}
                  product={product}
                  setShowNewProduct={setShowNewProduct}
                  updateProduct={updateProduct}
                  products={products}
                  deleteProductHandler={deleteProductHandler}
                  isEditable={purchase.statusId == 1 || !purchase.id}
                  setIsEdited={purchase.id ? () => {} : setIsEdited}
                />
              ))}
            </Tbody>
          )}
        </Table>
      </Box>

      <DeleteProduct
        isOpen={isDeleteProductOpen}
        setIsOpen={setIsDeleteProductOpen}
        product={deletedProduct}
        action={removeProduct}
      ></DeleteProduct>
    </>
  );
};

export default ProductList;
